import { render, staticRenderFns } from "./newsIntroduce.vue?vue&type=template&id=074168c6&scoped=true&"
import script from "./newsIntroduce.vue?vue&type=script&lang=js&"
export * from "./newsIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./newsIntroduce.vue?vue&type=style&index=0&id=074168c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074168c6",
  null
  
)

export default component.exports